import api from '@/logic/api'

export default {
  getWebinars: () => api.get('/webinars'),
  getRecordings: () => api.get('/webinars/recordings'),
  join: (webinarId) => api.post(`/webinars/${webinarId}/join`),
}
